import * as yup from 'yup';
import { phoneRegExp } from '../utils'

export const loginSchema = yup.object({
	email: yup
		.string()
		.email()
		.required('Please enter email address!'),
	password: yup
		.string()
		.required('Please enter password!'),
    phone: yup
		.string()
		.matches(phoneRegExp, 'Phone number is not valid')
		.min(10, "to short")
		.max(10, "to long"),
});
